module.exports = __webpack_public_path__ + "static/dm-furnitureforliving-88717ba4089ce0a9000fc66205103b6b.webp";